import palette from './palette';

const {
  orange,
  light_gray,
  gray,
  light_blue,
  light_red,
  green,
  white,
  black,
  gray_transparency,
  white_opacity,
  blue_purple,
  light_gray2,
  blue_purple2,
  horizontal_white_opacity,
  light_gray3,
} = palette;

const colors = {
  // General Colors
  white_text: white,
  gray_icon: gray,
  subtitle: gray,
  black_text: black,
  divider: light_gray,
  white_background: white,

  // Buttons Color
  blue_purple_button: blue_purple,
  end_trip: light_red,

  // POI List Screens
  stars_rated: orange,
  stars_unrated: light_gray,
  list_number: light_blue,
  mp_flag: light_red,
  list_opacity: white_opacity,

  // POI Details Screen
  collapse_icon: light_gray,
  destination_circle: light_blue,
  box_shadow: gray_transparency,
  minute: light_blue,

  // MP Information Screen
  open_logo: green,
  parking_price: gray,

  // Edit Stop Screen
  remove_icon: light_red,
  menu_icon: gray,
  position_icon: light_blue,

  // Favorite Recent Screen
  icon: light_gray,

  // Waypoint Details Screen
  collapse_border: light_gray2,

  // Routes
  normal_traffic: blue_purple2,
  heavy_traffic: light_red,
  distance_traveled: light_gray2,

  // Filter Screen
  clear_text: light_blue,
  any_button: light_blue,
  horizontal_opacity: horizontal_white_opacity,
  star_white: white,
  disabled_toggle: light_gray3,
  checked_toggle: light_blue,
  toggle_circle: white,

  // Sort By Screen
  radio_unchecked: gray,
  radio_checked: light_blue,
};

export default colors;
